export const API_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "http://10.0.0.105:8080";
export const ENV = process.env.REACT_APP_ENV ?? "dev";
export const MAX_CHARACTERS = 15;
export const MAX_PREVIEW_MB = 100;

// OAuth
export const OAUTH_ENABLED = `${process.env.REACT_APP_OAUTH_ENABLED}`;
export const OAUTH_REDIRECT_URI = `${process.env.REACT_APP_UI_URL}${process.env.REACT_APP_OAUTH_CALLBACK_ROUTE}`;
export const OAUTH_CLIENT_ID = process.env.REACT_APP_OAUTH_CLIENT_ID;

// APIs
export const API_TOKEN_ENDPOINT = `${API_URL}/oauth`;
